<template>
  <section>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <HeaderSmall :pageTitle="trans[lang].title" />
    <div class="container">
    <section class="section m-y-xl">
      <div class="content">
        <h1>{{pageData.title}}</h1>
        <div v-html="$marked(pageData.content)"></div>
      </div>

      <div class="gall" v-if="pageData.gallery">
        <div v-for="(item, index) in pageData.gallery "
              v-bind:key="item.id"
        >
        <img class="imgb" :src="$mySite.resurces + pageData.gallery[index].url" alt=""/>
        
        </div>
      </div>

      <div class="files m-t-md" v-if="fileCount>0">
        <div class="content"><h3>{{trans[lang].files}}</h3></div>
        <div v-for="(item, index) in pageData.docs"
              v-bind:key="item.id"
        >
        <a :href="$mySite.resurces + pageData.docs[index].url"> {{pageData.docs[index].name + pageData.docs[index].ext}} </a>
        
        </div>
      </div>

      <div class="buttons">
        <button @click="showDonate()" class="button is-success m-t-md">{{$locales[lang].donate}}</button>
      </div>


    </section>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import HeaderSmall from "@/components/HeaderSmall.vue";
export default {
  name: "project-item",
  components: {
    HeaderSmall
  },
  data() {
    return {
      hasItems: true,
      isLoading: false,
      fileCount: 0,
      pageData: {
        content: ""
      },
      trans:{
        en: {
          title: "Projects",
          files: "Files",
          description: "Slobozia Christian Baptist Church Projects to support children education and poor families.",       
          },
        ru: {
          title: "Проекты",
          files: "Файлы",
          description: "Проекты помощь бедным семьям и детям",
         },
      },           
      hasMeta: {
        title: "Projects",
        description: "Slobozia Christian Baptist Church Projects to support children education and poor families.",
      }
    };
  },
  methods: {
   loadPageData() {
     //$route.params.id
      let getFrom = this.lang+"-projects/"+this.$route.params.id;
      this.isLoading = true;
      this.axios
        .get(getFrom)
        .then(response => {
          this.isLoading = false;
          if (response.data.id) {
            this.pageData = response.data;
            this.fileCount = this.pageData.docs.length;
            this.hasMeta.title = response.data.title;
          } else {
            console.log("Error getting data");
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
        });
      //.finally(() => (this.loading = false));
    },
    showDonate() {
      this.$router.push({ path: "/donations"});
    },
    doMeta(){
      if(this.lang){
        this.hasMeta.title = this.trans[this.lang].title;
        this.hasMeta.description = this.trans[this.lang].description;
      }
    }
  },
  mounted() {
    this.loadPageData();
    this.doMeta();
  },
  computed: {
    ...mapState(["lang"]),
  },
  watch:{
    "$route.params.id": function() {
      this.loadPageData();
    },
    lang: function () {
      this.loadPageData();
      this.doMeta();
    }
  },
  metaInfo() {
    return {
      title: this.$mySite.title,
      titleTemplate: this.hasMeta.title + " | %s",
      htmlAttrs: {
        lang: this.lang
      },
      meta: [
        {
          name: "description",
          content: this.hasMeta.description
        },
        {
          property: "og:title",
          content: this.$mySite.title,
          vmid: "og:title"
        },
        {
          property: "og:description",
          content: this.hasMeta.description,
          vmid: "og:description"
        },
        {
          property: "og:image",
          content: this.$mySite.image,
          vmid: "og:image"
        },
        {
          property: "og:url",
          content: this.$mySite.url,
          vmid: "og:url"
        }
      ]
    };
  } //end meta
};
</script>
<style scoped>
  .gall{
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    row-gap: 10px;
  }
  @media only screen and (max-width: 600px) {
    .gall{    
      grid-template-columns: 1fr;
      column-gap: 10px;
      row-gap: 10px;
    }
  }
</style>